<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Recommendation Visa Check</h3>
      </v-flex>
      <v-flex lg12>
        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex xs4>
              <v-text-field :elevation="0" class="hidden-sm-and-down" flat hide-details placeholder="Application Number"
                prepend-inner-icon="mdi-equal-box" solo v-model="visa_number"></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field :elevation="0" class="hidden-sm-and-down" flat hide-details placeholder="Passport Number"
                prepend-inner-icon="mdi-equal-box" solo v-model="passport_number"></v-text-field>
            </v-flex>
            <v-btn color="primary" class="mt-1" @click="checkVisa" :loading="loading">Check Status</v-btn>
          </v-layout>
        </v-card>
      </v-flex>

      <!-- Show while loading -->
      <v-flex lg12 v-if="loading" class="mt-4">
        <v-alert type="info" outlined>Loading visa details...</v-alert>
      </v-flex>
      <!-- Show data table if visa found -->
      <v-flex lg12 v-else-if="Object.keys(visa).length > 0" class="mt-4">
        <v-card>
          <v-card-title class="headline font-weight-bold">
            Visa Details for {{ visa.fullName }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <strong>Full Name:</strong> {{ visa.fullName }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Gender:</strong> {{ visa.gender }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Passport No:</strong> {{ visa.passportNo }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Country:</strong> {{ visa.countryName }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Address:</strong> {{ visa.address }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Applicant Type:</strong> {{ visa.visaApplicantTypeName }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Last Visa Status:</strong> {{ visa.lastVisaStatusName }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Last Visa Expiry Date:</strong> {{ formatDate(visa.lastVisaExpiryDate) }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Visa From:</strong> {{ formatDate(visa.visaFromDate) }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Visa Till:</strong> {{ formatDate(visa.visaTillDate) }}
              </v-col>
            </v-row>
            <v-divider class="my-3"></v-divider>
            <div>
              <h4 class="font-weight-bold mb-2">Documents</h4>
              <v-list dense>
                <v-list-item v-for="doc in visa.documentList" :key="doc.documentTypeId"
                  class="py-1 d-flex justify-space-between align-center" :class="{
                    'green lighten-5': doc.documents.length > 0 && !!doc.documents[0].documentGuid,
                    'grey lighten-4': !(doc.documents.length > 0 && !!doc.documents[0].documentGuid)
                  }" :clickable="doc.documents.length > 0 && !!doc.documents[0].documentGuid"
                  @click="doc.documents.length > 0 && doc.documents[0].documentGuid && downloadDocument(doc.documents[0].documentGuid)">
                  <v-list-item-content>
                    <div>
                      <span :class="{
                        'text-decoration-underline': doc.documents.length > 0 && !!doc.documents[0].documentGuid
                      }">
                        {{ doc.documentTypeName }}
                      </span>
                      <span v-if="doc.documents.length > 0">
                        ({{ doc.documents[0].name }})
                      </span>
                      <span v-if="doc.isMandatory" class="red--text font-italic">* Mandatory</span>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
            <!-- REPLACE the existing Documents div inside v-card-text -->
            <v-divider class="my-3"></v-divider>

            <h4 class="font-weight-bold mb-3">
              <v-icon small class="mr-1">mdi-file-document-multiple</v-icon>
              Application Documents
            </h4>

            <v-expansion-panels accordion flat>
              <v-expansion-panel
                  v-for="docType in otherDocData"
                  :key="docType.documentTypeId"
                  class="mb-1"
                  style="border: 1px solid #e0e0e0; border-radius: 6px !important;"
              >
                <v-expansion-panel-header class="py-2">
                  <div class="d-flex align-center justify-space-between" style="width:100%">
                    <div class="d-flex align-center">
                      <v-icon small class="mr-2" :color="docType.documents.length > 0 ? 'success' : 'grey'">
                        {{ docType.documents.length > 0 ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                      </v-icon>
                      <span class="font-weight-medium" style="font-size:13px">
            {{ docType.documentTypeName }}
          </span>
                      <span class="ml-1 grey--text" style="font-size:11px">
            ({{ docType.documentTypeNameNp }})
          </span>
                    </div>
                    <div class="d-flex align-center mr-4" style="gap:6px">
                      <v-chip
                          x-small
                          :color="docType.documents.length > 0 ? 'success' : 'grey lighten-1'"
                          :text-color="docType.documents.length > 0 ? 'white' : 'grey darken-2'"
                      >
                        {{ docType.documents.length }} file{{ docType.documents.length !== 1 ? 's' : '' }}
                      </v-chip>
                      <v-chip x-small color="red lighten-4" text-color="red darken-2" v-if="docType.isMandatory">
                        Mandatory
                      </v-chip>
                    </div>
                  </div>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <!-- No documents uploaded -->
                  <div v-if="docType.documents.length === 0" class="py-2 grey--text text--darken-1" style="font-size:13px">
                    <v-icon small class="mr-1">mdi-information-outline</v-icon>
                    No document uploaded for this type.
                  </div>

                  <!-- Documents list -->
                  <v-list dense v-else>
                    <v-list-item
                        v-for="(doc, idx) in docType.documents"
                        :key="idx"
                        class="px-0 py-1"
                        style="border-bottom: 1px solid #f5f5f5; min-height: 36px;"
                    >
                      <v-list-item-icon class="mr-2 my-auto">
                        <v-icon small color="red darken-1">mdi-file-pdf-box</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title style="font-size:12px">{{ doc.name }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action class="my-auto">
                        <v-btn
                            x-small
                            outlined
                            color="primary"
                            :loading="downloadingUrl === doc.documentUrl"
                            @click="downloadDocumentByUrl(doc.documentUrl)"
                        >
                          <v-icon x-small class="mr-1">mdi-eye</v-icon>

                          View
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </v-flex>
      <!-- Show if no visa found after check -->
      <v-flex lg12
        v-else-if="checkPerformed && !loading && visa_number && passport_number && Object.keys(visa).length === 0"
        class="mt-4">
        <v-alert type="warning" outlined>No visa found for the provided information.</v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ListItemDetail from '../../components/ListItemDetail';
import { VERSIONED_API_URL } from "../../config/config";
import Http from 'axios';
import FormErrorDisplayHandler from "../../components/FormErrorDisplayHandler";
import ConfirmationHeaderText from "../../components/ConfirmationHeaderText";
import NewDatePicker from "../../components/NewDatePicker";
import FileInput from "../../components/FileInput";
import MultipleFileUpload from "../../components/MultipleFileUpload";
import { validationMixin } from "../../mixins/validationMixin";
import { commonListMixin } from "../../mixins/commonListMixin";
import { passportTypes, visa_plans } from "../../constants/AppConstant";
import { buildFormData } from "../../helpers/FormedData";
export default {
  data() {
    return {
      visa: {},
      otherDocData: {},
      visa_number: '',
      passport_number: '',
      loading: false,
      checkPerformed: false,
      downloadingUrl: null,
      headers: [
        { text: 'Full Name', value: 'fullName' },
        { text: 'Gender', value: 'gender' },
        { text: 'Passport No', value: 'passportNo' },
        { text: 'Country', value: 'countryName' },
        { text: 'Address', value: 'address' },
        { text: 'Visa Type', value: 'lastVisaStatusName' },
        { text: 'Applicant Type', value: 'visaApplicantTypeName' },
        { text: 'Last Visa Expiry', value: 'lastVisaExpiryDate' },
        { text: 'Visa From', value: 'visaFromDate' },
        { text: 'Visa Till', value: 'visaTillDate' },
        { text: 'Documents', value: 'documentList' },
      ]
    }
  },
  name: "ConsularCheck",
  components: {
    MultipleFileUpload,
    FileInput,
    NewDatePicker,
    ConfirmationHeaderText,
    FormErrorDisplayHandler,
    ListItemDetail
  },
  mixins: [validationMixin, commonListMixin],
  computed: {
    ...mapGetters({
      countries: "NewVisaEntry/countries",
      offices: "OfficeList/offices"
    }),
    passportLabel() {
      let label = "Passport";
      if (this.visaData.passport.passport_type && this.visaData.passport.passport_type.toLowerCase() === 'travel document')
        label = "Travel Document";
      return label;
    },
    visaTypes() {
      return this.$store.state.VisaTypeList.all.filter((i) => i.slug.includes("consular"));
    },
  },
  methods: {
    ...mapActions("NewVisaEntry", ["validateVisaEntry", "getCountries", "getVisaTypeCondition", "getVisaTypeConditionAll"]),
    checkVisa() {
      this.visa = {};
      this.otherDocData = {};
      this.checkPerformed = true;
      if (this.visa_number && this.passport_number) {
        this.add_box = false;
        this.loading = true;
        Http.get(`${VERSIONED_API_URL}/recommendation/visa-detail/${this.visa_number}/${this.passport_number}`)
          .then((res) => {
            const mainData = res && res.data && res.data.data;
            const otherDoc=res && res.data && res.data.documents
            if (mainData && mainData.status && mainData.data) {
              this.visa = mainData.data;
            } else {
              this.visa = {};
            }
            if (otherDoc && otherDoc.status && otherDoc.data) {
              this.otherDocData = otherDoc.data;
            } else {
              this.otherDocData = {};
            }
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;

            // const message = err?.response?.data?.message;
            var message = err && err.response && err.response.data && err.response.data.message;
            if (message && message.toLowerCase().includes('visa applicant not found')) {
              _this.visa = {};
              _this.$store.commit('Notification/showError', 'Records not found');
            } else {
              this.$store.commit('Notification/showError', 'Something went wrong');
            }
          });
      } else {
        this.$store.commit('Notification/showError', 'Please enter visa number');
      }
    },
    downloadDocument(documentGuid) {
      const url = `${VERSIONED_API_URL}/recommendation/download-document/${documentGuid}`;
      const token = localStorage.getItem('access_token');

      Http.get(url, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const fileURL = window.URL.createObjectURL(blob);
          window.open(fileURL, '_blank');
        })
        .catch((error) => {
          this.$store.commit('Notification/showError', 'Unable to download document.');
          console.error("Document download error:", error);
        });
    },
    async downloadDocumentByUrl(url) {
      this.downloadingUrl = url;
      try {
        const response = await Http.post(
            `${VERSIONED_API_URL}/recommendation/download-document-by-url`,
            { url: url },
            { responseType: 'blob' }
        );
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const fileURL = window.URL.createObjectURL(blob);
        window.open(fileURL, '_blank');
      } catch (error) {
        this.$store.commit('Notification/showError', 'Unable to download document.');
        console.error('Document download error:', error);
      } finally {
        this.downloadingUrl = null;
      }
    },
    formatDate(date) {
      if (!date) return 'N/A';
      return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },
    proceed() {
      console.log('formdata', this.visaData);
      let formData = new FormData();
      buildFormData(formData, this.visaData);
      if (this.visaData.visa_type === this.dependent_visa_id) {
        formData.set("dependent_visa", true);
        formData.set("dependent_passport_no", this.visaData.dependent_passport_no);
        formData.set("dependent_visa_no", this.visaData.dependent_visa_no);
      }
      let files = this.visaData.attachments;
      if (files !== undefined) {
        for (let i = 0; i < files.length; i++) {
          formData.append(`files[${i}]`, files[i]);
        }
      }
      if (this.$refs.formRef.validate()) {
        this.loading = true;
        Http.post(VERSIONED_API_URL + '/visa/entry', formData)
          .then(res => {
            this.loading = false;
            this.$store.commit("Notification/showSuccess", res.data.message);
            this.visa_number = null;
            this.visa = {};
            this.travellers = [];
            this.add_box = false;
            this.visaData = {
              passport: {}
            }
          })
          .catch(error => {
            this.loading = false;
            if (error.response.status === 422) {
              this.$store.commit('Notification/showError', error.response.data.message);
              this.errors = error.response.data.errors;
            }
            if (error.response.status === 409) {
              this.$store.commit('Notification/showError', 'Visa with the same visa number already exists');
              this.errors = error.response.data.errors;
            }
          })
      } else {
        this.$store.commit("Notification/showError", "Invalid form details");
      }
    },
  },
  mounted() {
    this.$store.commit('NewVisaEntry/resetState');
    if (this.$store.state.NewVisaEntry.countries.length === 0) {
      this.getCountries();
    }
    if (this.$store.state.VisaTypeList.all.length === 2) {
      this.$store.dispatch("VisaTypeList/fetchAll");
    }
    if (this.$store.state.OfficeList.offices.length === 0) {
      this.$store.dispatch('OfficeList/fetchAll');
    }
  }
}
</script>
<style scoped></style>